import type { Prototype } from "../prototype-types";

export const rannieTeodoroPrototypes: Prototype[] = [
  {
    id: "brand-banners",
    name: "Brand Banners",
    path: "/rt/brand-banners",
    description:
      "Prototype exploring banner designs for the brand experience on Faire.",
    owner: "Rannie",
    createdAt: "2026-01-08",
    lastUpdated: "2026-01-08",
    surfaceArea: "Brand",
    category: "experimental",
    status: "legacy",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/86daadb753cd41da32f923e2ddde3927666659b9ddd5278200f027021b8e5fbc.png",
    creationTool: "cursor",
  },
];
